import { NavLink } from 'react-router-dom'
import { authClient } from '@/lib/auth-client'
import { Button } from '@/components/ui/button'

const desktopLinkClass = 'px-6 py-3 rounded-lg font-semibold text-base transition-all duration-300'
const desktopActiveClass = 'bg-blue-100 text-gray-900'
const desktopInactiveClass = 'text-gray-600 hover:text-gray-900 hover:bg-gray-100'

const mobileLinkClass = 'flex flex-col items-center justify-center gap-1 flex-1 h-full transition-all duration-300'
const mobileActiveClass = 'text-blue-600'
const mobileInactiveClass = 'text-gray-500'

export function TabNavigation() {
  const { data: session } = authClient.useSession()

  const handleSignOut = () => {
    authClient.signOut({
      fetchOptions: {
        onSuccess: () => window.location.assign('/sign-in'),
      },
    })
  }

  return (
    <>
      {/* Desktop: Top Tab Navigation */}
      <div className="hidden md:flex md:items-center md:justify-center md:gap-4 md:mb-8">
        <div className="inline-flex bg-gray-100 rounded-xl p-1 border border-gray-200">
          <NavLink to="/" end className={({ isActive }) => `${desktopLinkClass} ${isActive ? desktopActiveClass : desktopInactiveClass}`}>
            Scan Cards
          </NavLink>
          <NavLink to="/inventory" className={({ isActive }) => `${desktopLinkClass} ${isActive ? desktopActiveClass : desktopInactiveClass}`}>
            Manage Inventory
          </NavLink>
          <NavLink to="/offers" className={({ isActive }) => `${desktopLinkClass} ${isActive ? desktopActiveClass : desktopInactiveClass}`}>
            Offers
          </NavLink>
          <NavLink to="/images" className={({ isActive }) => `${desktopLinkClass} ${isActive ? desktopActiveClass : desktopInactiveClass}`}>
            Images
          </NavLink>
          <NavLink to="/cardmarket" className={({ isActive }) => `${desktopLinkClass} ${isActive ? desktopActiveClass : desktopInactiveClass}`}>
            Cardmarket
          </NavLink>
          <NavLink to="/catalog" className={({ isActive }) => `${desktopLinkClass} ${isActive ? desktopActiveClass : desktopInactiveClass}`}>
            Catalog
          </NavLink>
        </div>
        {session?.user && (
          <Button variant="outline" size="sm" onClick={handleSignOut} className="border-gray-300 text-gray-700 hover:bg-gray-100">
            Sign out
          </Button>
        )}
      </div>

      {/* Mobile: Bottom Tab Navigation */}
      <div className="fixed bottom-0 left-0 right-0 md:hidden bg-[#242424] border-t border-white/10 z-50 h-16">
        <div className="flex justify-around items-center h-16">
          <NavLink to="/" end className={({ isActive }) => `${mobileLinkClass} ${isActive ? mobileActiveClass : mobileInactiveClass}`}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z" />
              <circle cx="12" cy="13" r="4" />
            </svg>
            <span className="text-xs font-medium">Scan</span>
          </NavLink>
          <NavLink to="/inventory" className={({ isActive }) => `${mobileLinkClass} ${isActive ? mobileActiveClass : mobileInactiveClass}`}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
              <polyline points="3.27 6.96 12 12.01 20.73 6.96" />
              <line x1="12" y1="22.08" x2="12" y2="12" />
            </svg>
            <span className="text-xs font-medium">Inventory</span>
          </NavLink>
          <NavLink to="/offers" className={({ isActive }) => `${mobileLinkClass} ${isActive ? mobileActiveClass : mobileInactiveClass}`}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
              <polyline points="14 2 14 8 20 8" />
              <line x1="16" y1="13" x2="8" y2="13" />
              <line x1="16" y1="17" x2="8" y2="17" />
              <polyline points="10 9 9 9 8 9" />
            </svg>
            <span className="text-xs font-medium">Offers</span>
          </NavLink>
          <NavLink to="/images" className={({ isActive }) => `${mobileLinkClass} ${isActive ? mobileActiveClass : mobileInactiveClass}`}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
              <circle cx="8.5" cy="8.5" r="1.5" />
              <polyline points="21 15 16 10 5 21" />
            </svg>
            <span className="text-xs font-medium">Images</span>
          </NavLink>
          <NavLink to="/cardmarket" className={({ isActive }) => `${mobileLinkClass} ${isActive ? mobileActiveClass : mobileInactiveClass}`}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <line x1="12" y1="1" x2="12" y2="23" />
              <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
            </svg>
            <span className="text-xs font-medium">CM</span>
          </NavLink>
          <NavLink to="/catalog" className={({ isActive }) => `${mobileLinkClass} ${isActive ? mobileActiveClass : mobileInactiveClass}`}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <ellipse cx="12" cy="5" rx="9" ry="3" />
              <path d="M21 12c0 1.66-4 3-9 3s-9-1.34-9-3" />
              <path d="M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5" />
            </svg>
            <span className="text-xs font-medium">Catalog</span>
          </NavLink>
          {session?.user && (
            <button type="button" onClick={handleSignOut} className={`${mobileLinkClass} ${mobileInactiveClass}`}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                <polyline points="16 17 21 12 16 7" />
                <line x1="21" y1="12" x2="9" y2="12" />
              </svg>
              <span className="text-xs font-medium">Sign out</span>
            </button>
          )}
        </div>
      </div>
    </>
  )
}
